import { IPostService } from './IPostService';

class PostService implements IPostService {
  postToParent = (message: string) => {
    window.parent.postMessage(message, '*');
  };
}

export default PostService;
